import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  settheGrievanceCreateActions,
  settheGrievanceRetrieveActions,
  settheGrievanceEditActions,
} from "../../../Redux/Slice";
const GrievanceTypeCreate = (props) => {
  const { setShow, show, currentPage, EditID , search } = props;
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  const state = useSelector((state) => state);
  const handleClose = () => {
    setShow(false);
  };
  const Headers = {
    grievance_type: "",
    purpose: "",
  };
  const [Data, setDatas] = useState(Headers);
  const [GrievanceEr, setrievanceErt] = useState("");
  const [PurposeErr, setPurposeErr] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    if (EditID != undefined && EditID != ""  ) {
      const payload = {
        EditID: EditID,
      };
      dispatch(settheGrievanceRetrieveActions(payload));
    }
  }, []);
  console.log(
    state.GrievanceretrieveCall.GrievanceRetrieve,
    "GrievanceRetrieve" , EditID
  );

  useEffect(() => {
    if (
      EditID != undefined && EditID != ""  && 
      state.GrievanceretrieveCall.GrievanceRetrieve != undefined
    ) {
      setDatas({
        ...Data,
        grievance_type:
          state.GrievanceretrieveCall.GrievanceRetrieve.grievance_type,
        purpose: state.GrievanceretrieveCall.GrievanceRetrieve.purpose,
      });
    }
  }, [state.GrievanceretrieveCall.GrievanceRetrieve]);

  const HandleChanges = (e) => {
    setDatas((pre) => {
      return {
        ...pre,
        [e.target.name]: e.target.value,
      };
    });
  };
   console.log(EditID , "EditID");
  const HandleSubmit = () => {
    var a = 0;
    if (EditID == undefined || EditID == "") {
      if (Data.grievance_type == "") {
        setrievanceErt("*Grievance Type is required");
        a = 1;
      }
      if (Data.purpose == "") {
        setPurposeErr("*purpose is required");
        a = 1;
      }
      if (a == 0) {
        console.log(Data, "datas");
        const payload = {
          Data: Data,
          search:search, currentPage:currentPage
        };
        dispatch(settheGrievanceCreateActions(payload, props.setShow()));
      }
    } else if (EditID != undefined || EditID != "") {
      if (Data.grievance_type == "") {
        setrievanceErt("*Grievance Type is required");
        a = 1;
      }
      if (Data.purpose == "") {
        setPurposeErr("*purpose is required");
        a = 1;
      }
      if (a == 0) {
        /// console.log(Data, "datas");
        const payload = {
          Data: Data,
          search:search,
          EditID: EditID,
          currentPage:currentPage
        };
        dispatch(settheGrievanceEditActions(payload, props.setShow()));
      }
    }
  };
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "30%" }}>
            <div className="asds">
              <div class="ModalHeader">
                {EditID != undefined && EditID != "" ? (
                  <span className="UserCreate"> Grievance Type  </span>
                ) : (
                  <span className="UserCreate"> Grievance Type  </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>
            </div>
            <form
              class="row g-3 form-fields-wrapper"
              onClick={HandleSubmits}
              style={{ padding: "20px" }}
            >
              <div className="col-12 field-div">
                <label className="form-label" style={{ fontSize: "15px" }}>
                  Grievance Type
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  value={Data.grievance_type}
                  autoComplete="off"
                  onChange={(e) => {
                    HandleChanges(e);
                    setrievanceErt("");
                  }}
                  required
                  name="grievance_type"
                  style={{
                    padding: "10px",
                  }}
                ></input>
                <p style={{ color: "red", marginTop: "5px" }}>{GrievanceEr}</p>
              </div>
              <div className="col-12 field-div">
                <label className="form-label" style={{ fontSize: "15px" }}>
                  Description
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  value={Data.purpose}
                  autoComplete="off"
                  onChange={(e) => {
                    HandleChanges(e);
                    setPurposeErr("");
                  }}
                  required
                  name="purpose"
                  style={{
                    padding: "10px",
                  }}
                ></input>
                <p style={{ color: "red", marginTop: "5px" }}>{PurposeErr}</p>
              </div>
            </form>
            <div
              className="RoleButton"
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                class="btn  SaveBtn"
                type="submit"
                onClick={(e) => {
                  HandleSubmit(e);
                  //    HandleEdits(e);
                }}
              >
                Submit
              </button>
              <button class="btn CancelBtn" onClick={handleClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrievanceTypeCreate;
